export function Contact() { 

    return (
        <section className="section-card section-card--contact" id="contact">
            <div className="section-card__header">
                <p className="section-card__eyebrow">Let’s connect</p>
                <h2>Interested in working together?</h2>
            </div>
            <p>I’m always happy to talk through product ideas, front-end delivery, or legacy app challenges.</p>
            <div className="profile-overview__links">
                <a href="https://www.linkedin.com/in/jeanambait/" target="_blank" rel="noreferrer">LinkedIn</a>
                <a href="https://github.com/janejanejane/" target="_blank" rel="noreferrer">GitHub</a>
            </div>
        </section>
    );
}